import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";

import AssignmentTurnedIn from "@material-ui/icons/AssignmentTurnedIn";

import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import InfoArea from "../../../components/InfoArea/InfoArea";
import Button from "../../../components/CustomButtons/Button";

import featuresStyle from "../../../assets/jss/material-kit-pro-react/views/sectionsSections/featuresStyle";

function SectionFeatures({ ...props }) {
    const { classes, response, ...rest } = props;

    return (
        <div className="cd-section" {...rest}>
            <div className={classes.container}>
                <div className={classes.features1}>
                    <br/>
                    <br/>
                    <GridContainer>
                        <GridItem xs={12} sm={4} md={4}>
                            <InfoArea vertical icon={AssignmentTurnedIn} title="Transacción finalizada" iconColor="success"/>
                            <Button href="/" color="success" round>Volver al Inicio</Button>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={8} className={classes.textLeft}>
                            <h3 className={classes.title}>Resultado de la Transacción</h3>
                            <p className={classes.description}><strong>Empresa: </strong>{decodeURIComponent((response.merchant_name+"").replace(/\+/g, ' '))}</p>
                            <p className={classes.description}><strong>Estado de la Transacción: </strong>
                                {response.polTransactionState === '4' ? 'Aprobada' : (response.polTransactionState === '5' ? 'Expirada' : 'Declinada')}
                            </p>
                            <p className={classes.description}><strong>Mensaje: </strong>
                                La transacción ha sido {response.polTransactionState === '4' ? 'aprobada' : (response.polTransactionState === '5' ? 'expirada' : 'declinada')}
                            </p>
                            <p className={classes.description}><strong>Referencia de la Transacción: </strong>{response.referenceCode}</p>
                            <p className={classes.description}><strong>Descripción: </strong>{decodeURIComponent((response.description+"").replace(/\+/g, ' '))}</p>
                            <p className={classes.description}><strong>Recaudador: </strong>{response.lapPaymentMethod}</p>
                            <p className={classes.description}><strong>Método de pago: </strong>{response.lapPaymentMethodType}</p>
                            <p className={classes.description}><strong>Valor: </strong>{response.currency}$ {response.TX_VALUE}</p>
                            {/*<p className={classes.description}><strong>Impuestos: </strong>{response.currency}$ {response.TX_TAX}</p>*/}
                            <p className={classes.description}><strong>Email del Comprador: </strong>{decodeURIComponent(response.buyerEmail)}</p>
                            {!!response.authorizationCode ?
                                <p className={classes.description}><strong>Código de autorización: </strong>{response.authorizationCode}</p>
                                :
                                null
                            }
                        </GridItem>
                    </GridContainer>
                </div>
            </div>
        </div>
    );
}

export default withStyles(featuresStyle)(SectionFeatures);



// WEBPACK FOOTER //
// ./src/views/ReservationPaymentResultPage/Sections/SectionFeatures.js